import { FormData } from "../../data/models";
import axios from "axios";
import { toast } from "react-toastify";
import { getUTMTrackingData } from "../utils";

export const sendEmail = async ({
  formData,
  mode,
  id,
}: {
  formData: FormData;
  mode: string;
  id: string | undefined;
}) => {
  const formattedData = formatDataForBackend(formData);
  //console.log(formattedData);
  if (mode === "Zatražite ponudu") {
    try {
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/${id}/offer/?brand=CITROEN`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(
        "Upit uspjesno poslan, zahvaljujemo na iskazanom interesu za marku Citroën!"
      );
      toast.success(
        "Vezano za vaš upit, uskoro će vas kontaktirati Citroën prodajni savjetnik."
      );
      //console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Axios error:", error.response?.data || error.message);
        toast.error(
          error.response?.data?.message ||
            "Došlo je do pogreške pri slanju upita."
        );
      } else {
        console.error("Unexpected error:", error);
        toast.error("Neočekivana pogreška pri slanju upita.");
      }
    }
  } else {
    try {
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/${id}/test/?brand=CITROEN`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(
        "Upit uspjesno poslan, zahvaljujemo na iskazanom interesu za marku Citroën!"
      );
      toast.success(
        "Vezano za vaš upit, uskoro će vas kontaktirati Citroën prodajni savjetnik."
      );
      //console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Axios error:", error.response?.data || error.message);
      } else {
        console.error("Unexpected error:", error);
      }
    }
  }
};

export const formatDataForBackend = (formData: FormData) => {
  const formattedData: Record<string, any> = {
    first_name: formData.general["Ime"],
    last_name: formData.general["Prezime"],
    email: formData.general["Email adresa"],
    phone: formData.general["Mobilni telefon"],
    location: formData.general["Mjesto"],
    postalcode: formData.general["Poštanski broj"],
    street: formData.general["Ulica"],
    house_number: formData.general["Kućni broj"],
    car_info: {
      vin: formData.vehicle["Broj odabranog vozila"],
      model: formData.vehicle["Model vozila"],
    },
    ...getUTMTrackingData(), // Add UTM tracking data
  };

  if (formData.conditions.includes("newsletter")) {
    formattedData.newsletter = true;
  } else {
    formattedData.newsletter = false;
  }
  if (formData.conditions.includes("analyticsConsent")) {
    formattedData.analytics = true;
  } else {
    formattedData.analytics = false;
  }

  // Add `additional` only if filled out
  if (formData.additional["Naslov"] || formData.additional["Poruka"]) {
    formattedData.additional = {
      title: formData.additional["Naslov"],
      message: formData.additional["Poruka"],
    };
  }

  return formattedData;
};
